import styles from "./Card.module.css";
import { UseCase } from "../../api";
import { DEFAULT_USE_CASE_ICON, MATERIAL_ICON_MAP } from "./constants";

interface CardProps {
  onClick: (title: string, key: string, confirmationMessage?: string) => void;
  useCase: UseCase | undefined;
}

const Card: React.FC<CardProps> = ({ onClick, useCase }) => {
  if (!useCase) return null;
  const isDraft = useCase.status == "Draft" ? true : false;
  const iconName = useCase.icon?.match(/^:material\/(.+):$/)?.[1] ?? "";
  const IconComponent = MATERIAL_ICON_MAP[iconName] ?? DEFAULT_USE_CASE_ICON;
  return (
    <div
      className={isDraft ? styles.cardItemDraft : styles.cardItem}
      onClick={() =>
        onClick(useCase.name, useCase.id, useCase.confirmationMessage)
      }
    >
      {useCase.requirements !== "" && (
        <span className={styles.tooltiptext}>{useCase.requirements}</span>
      )}
      <div className={styles.cardContent}>
        <div className={styles.iconsContainer}>
          <div className={isDraft ? styles.circleDraft : styles.circle}>
            <IconComponent className={styles.icon} />
          </div>
        </div>
        <div className={styles.text}>
          <div className={isDraft ? styles.titleDraft : styles.title}>{useCase.name}</div>
          <div className={styles.description}>{useCase.description}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
